import React from 'react';

// import HorizontalScroll from '@components/HorizontalScroll';
// import ListViewType from '@components/ListViewType';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';

// import { LIST_VIEW_TYPE } from '@/constants/constant';

const SampleDetailsTopHeader = ({
	toggleFilter
	// setDefaultViewType,
	// elementRef,
	// defaultViewType,
	// cardType
}) => {
	return (
		<>
			<div className="filter-container-top on-sample-details">
				<div className="filters">
					<div className="filter-toggle" onClick={() => toggleFilter()}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					<Chip />
				</div>
				<div className={`filter-actions collections-filter-actions`}>
					<Search placeholder="Design name & number" identifier="search" />
					{/* {cardType === 'SAMPLE_VIEW' && (
						<ListViewType
							type="SAMPLE_DETAILS"
							onSelectType={(selected) => setDefaultViewType(selected)}
						/>
					)}
					{(cardType === 'DEVELOPMENT' ||
						(cardType === 'SAMPLE_VIEW' && defaultViewType === LIST_VIEW_TYPE.LIST_VIEW)) && (
						<HorizontalScroll elementReference={elementRef.current} />
					)} */}
				</div>
			</div>
		</>
	);
};

export default SampleDetailsTopHeader;
